export var requestRemoteConfig = function (_a) {
    var appKey = _a.appKey, version = _a.version, deviceId = _a.deviceId;
    return fetch("https://app.saygames.io/config/".concat(appKey, "?version=").concat(version, "&device_id=").concat(deviceId)).then(function (response) {
        if (response.ok) {
            return response.json();
        }
        throw new Error();
    });
};
//# sourceMappingURL=remote-config.js.map